import React from 'react';
import getObjectTitle from './getObjectTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_PROD } from '@scale/frontend-lib/constants';
import { IconButton } from 'react-scale/components/design-system';

const LookupHeader: React.FC<{ object: any; refresh?: () => void }> = props => {
  const { object, refresh } = props;
  const title = getObjectTitle(object);

  const objectId: string = object._id;
  const devLink = `http://localhost:3003/corp/lookup/${encodeURIComponent(objectId)}`;
  const prodLink = `https://dashboard.scale.com/corp/lookup/${encodeURIComponent(objectId)}`;

  return (
    <div>
      <div className="title-row">
        <span className="title">{title}</span>
        {refresh && (
          <IconButton color="primary" aria-label="add to shopping cart" onClick={refresh}>
            <FontAwesomeIcon icon="sync-alt" />
          </IconButton>
        )}
      </div>
      <div className="id flex items-center">
        {object._id}
        <a
          className="link"
          href={IS_PROD ? devLink : prodLink}
          title={IS_PROD ? 'Lookup in Localhost' : 'Lookup in Prod'}
        >
          <FontAwesomeIcon icon="random" size="xs" />
        </a>
      </div>
      <style jsx>{`
        .title-row {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
          flex-grow: 1;
        }
        .id {
          font-size: 14px;
          line-height: 1.7;
        }
        .link {
          text-decoration: none;
          font-weight: normal;
          color: black;
          padding-left: 6px;
          opacity: 0.65;
        }
        .link:hover {
          opacity: 1;
        }
        .link:active {
        }
      `}</style>
    </div>
  );
};

export default LookupHeader;
